import React from "react";
import { Link } from "react-router-dom";
export const FloatingButton = () => {
    return (
        <div className="py-2 mt-3">
            <div className="d-flex align-items-center  justify-content-center gap-4">
                <div className="text-center">
                    <Link
                        to="#"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#menu-transfer"
                        className="icon icon-xxl rounded-m justify-content-center align-items-center d-flex"
                        style={{
                            width: "74px",
                            height: "74px",
                            background: "#201F24",
                        }}
                    >
                        <i className="font-31 color-white bi bi-arrow-down-circle opacity-80"></i>
                    </Link>
                    <h6
                        className="font-15 font-500 mb-0 pt-2"
                        style={{
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: "13px",
                        }}
                    >
                        Deposit
                    </h6>
                </div>
                <div className="text-center">
                    <Link
                        to="#"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#menu-request"
                        className="icon icon-xxl rounded-m justify-content-center align-items-center d-flex"
                        style={{
                            width: "74px",
                            height: "74px",
                            background: "#201F24",
                            // paddingTop: "8px",
                        }}
                    >
                        <i className="font-31 color-white bi bi-arrow-up-circle opacity-80"></i>
                    </Link>
                    <h6
                        className="font-15 font-500 mb-0 pt-2"
                        style={{
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: "13px",
                        }}
                    >
                        Withdraw
                    </h6>
                </div>
                <div className="text-center">
                    <Link
                        to="#"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#menu-exchange"
                        className="icon icon-xxl rounded-m justify-content-center align-items-center d-flex"
                        style={{
                            width: "74px",
                            height: "74px",
                            background: "#201F24",
                            // paddingTop: "8px",
                        }}
                    >
                        {/* <i className="font-31 color-white bi bi-arrow-left-right opacity-80"></i> */}
                        <img
                            src="./images/store/home_exchange.png"
                            alt="exchange"
                            style={{ width: "22px", height: "22px" }}
                        />
                    </Link>
                    <h6
                        className="font-15 font-500 mb-0 pt-2"
                        style={{
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: "13px",
                        }}
                    >
                        Exchange
                    </h6>
                </div>
            </div>
        </div>
    );
};
